// initial state
const state = {
  year: 2015,
  mapLayer: "mapbox://styles/mapbox/outdoors-v11"
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  changeYear(state, year) {
    state.year = year;
  },
  changeMapLayer(state, name) {
    const layers = {
      Satellite: "mapbox://styles/mapbox/satellite-v9",
      Streets: "mapbox://styles/mapbox/streets-v11",
      "Satellite with Streets": "mapbox://styles/mapbox/satellite-streets-v11",
      Outdoors: "mapbox://styles/mapbox/outdoors-v11",
      Light: "mapbox://styles/mapbox/light-v10",
      Dark: "mapbox://styles/mapbox/dark-v10"
    };
    state.mapLayer = layers[name];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
